import classNames from 'classnames';
import { CardPreviewFront, type CardPreviewFrontProps } from './CardPreviewFront';
import { CardPreviewBack, type CardPreviewBackProps } from './CardPreviewBack';
import styles from './CardPreview.module.css';

/**
 * TODO(cvu): Localize the card preview.
 *
 * This card preview is currently localized for US. We need to localize it for
 * CA and GB/UK if it is to be used for those locales.
 *
 * Jira: https://block.atlassian.net/browse/BANKWEB-1065
 */

export interface CardPreviewProps extends CardPreviewFrontProps, CardPreviewBackProps {
  readonly showCardDetails?: boolean;
}

export const CardPreview = ({
  businessName,
  cardholder,
  cvc,
  expirationDate,
  fullPan,
  showCardDetails = false,
  signatureDataUri,
}: CardPreviewProps) => {
  const previewContainerClassName = showCardDetails
    ? classNames(styles.previewContainer, styles.previewContainerRotate)
    : styles.previewContainer;
  return (
    <div className={previewContainerClassName}>
      <CardPreviewFront
        className={classNames(styles.preview, styles.previewFront)}
        businessName={businessName}
        signatureDataUri={signatureDataUri}
      />
      <CardPreviewBack
        className={classNames(styles.preview, styles.previewBack)}
        cardholder={cardholder}
        cvc={cvc}
        expirationDate={expirationDate}
        fullPan={fullPan}
      />
    </div>
  );
};
